import script from "./ProfileAIConversations.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileAIConversations.vue?vue&type=script&setup=true&lang=js"

import "./ProfileAIConversations.vue?vue&type=style&index=0&id=4865c976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4865c976"]])

export default __exports__